<!--
 * @ Author: Your name
 * @ Create Time: 2019-07-30 10:38:55
 * @ Modified by: Your name
 * @ Modified time: 2019-07-31 16:23:24
 * @ Description: 上传安装包弹窗
 -->
<template>
  <div class="dialog-wrapper" v-loading="loading"
    element-loading-text="正在上传安装包"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.6)">
    <el-form :model="dialogFormData" label-width="90px" :rules="rules"
      label-position="right" ref="dialogForm" class="dialog-form" :inline="true">
      <el-form-item label="" prop='file'>
        <el-upload
          class="upload-demo"
          ref="upload"
          action="xx"
          :limit='1'
          :on-change='handleChange'
          :on-remove="handleRemove"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary" plain
            icon="el-icon-upload2">上传安装包</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="版本号" prop='versionNumber'>
        <el-input v-model="dialogFormData.versionNumber" placeholder="" size="small"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { VERSIONMANAGE } from '../../libs/api'

export default {
  name: '',
  props: {
    clickConfirm: {
      type: String,
      default: ''
    },
    uploadInstallPackageShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      dialogFormData: {
        versionNumber: '',
        file: ''
      },
      fileLists: [],
      rules: {
        file: [{ required: true, message: '请选择上传安装包', trigger: 'change' }],
        versionNumber: [{ required: true, message: '请输入版本号', trigger: 'blur' }]
      },
      uploadUrl: VERSIONMANAGE.UPLOAD
    }
  },
  watch: {
    clickConfirm(val) {
      if (val) { // 有数值则进行提交，否则中断
        this.submitForm('dialogForm') // 表单提交
      }
    },
    uploadInstallPackageShow() {
      this.initDialogStatus() // 初始化弹窗状态
    }
  },
  methods: {
    initDialogStatus() {
      this.resetForm('dialogForm') // 重置提示
      this.$refs.upload.clearFiles() // 清空已上传的文件列表
      this.$emit('endSubmit') // 重置按钮的loading状态
      this.loading = false
    },
    handleRemove(file, fileList) {
      if (fileList.length === 0) { // 重置未选择文件提醒
        this.dialogFormData.file = ''
      }
      this.fileLists = [...fileList]
    },
    handleChange(file, fileList) {
      this.dialogFormData.file = file
      this.fileLists = [...fileList]
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return false
        }
        this.$emit('startSubmit')
        this.loading = true
        // 将文件读成二进制数据， 并将表单数据发送给后台
        const { raw, name } = this.fileLists[0]
        this.readAsBinaryString(raw, name)
        return ''
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    readAsBinaryString(file, packageName) {
      const that = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onload = function(e) {
        const buffer = e.target.result // 此时是arraybuffer类型
        const hex = that.buf2hex(buffer)
        that.sendRequest(hex, packageName)
      }
    },
    buf2hex(buffer) {
      return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('')
    },
    sendRequest(file, packageName) { // 将表单发送给后台
      const { versionNumber } = this.dialogFormData
      this.$http.post(this.uploadUrl, { versionNumber, file, packageName })
        .then(res => {
          if (res.data.code === 1) {
            this.$notify.success({
              title: '提示',
              message: (res.data.msg || '上传安装包成功')
            })
          } else {
            this.$notify.error({
              title: '错误',
              message: (res.data.msg || '上传安装包失败')
            })
          }
          this.$emit('endSubmit', 'end')
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-wrapper{
  padding: 0px 35px;
  .dialog-form{
    display: flex;
    justify-content: center;
  }
}
</style>
